import { render } from "./posheduleForm.vue?vue&type=template&id=5ffa5f78&scoped=true"
import script from "./posheduleForm.vue?vue&type=script&lang=js"
export * from "./posheduleForm.vue?vue&type=script&lang=js"

import "./posheduleForm.vue?vue&type=style&index=0&id=5ffa5f78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffa5f78"]])

export default __exports__